import React from 'react';
import { useToast } from '../../hooks/useToast';
import Toast from './Toast';
import styles from './Toast.module.css';

const ToastContainer = () => {
  const { toasts, remove, config } = useToast();

  return (
    <div className={`${styles.container} ${styles[config.position]}`}>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          {...toast}
          onRemove={remove}
        />
      ))}
    </div>
  );
};

export default ToastContainer;
